import { RequestCustomerStatus, getNameStatusEndpoint } from 'cpfr-common';
import { DefaultBusinessMarketApiErrorCode } from '@cp-shared-19/common-utilities';
import { getSimpleDataFetchSlice } from '@cp-shared-19/frontend-integration';
import { CpDataApi } from 'cp-xhr';

const { reducer, fetchData, updateData } = getSimpleDataFetchSlice<
    RequestCustomerStatus,
    DefaultBusinessMarketApiErrorCode
>({
    dataName: 'NameChangeStatus',
    fetchCallback() {
        return CpDataApi.get<RequestCustomerStatus>(getNameStatusEndpoint()).then((response) => response.data);
    },
});

export default reducer;
export const fetchNameChangeStatus = fetchData;
export const updateNameChangeStatus = updateData;
